import dayjs from 'dayjs';

export const getAnalyticsWindowStart = () => dayjs().subtract(60, 'days').startOf('day');
